import { createTheme } from '@mantine/core';
import { DatePickerInput, DateTimePicker } from '@mantine/dates';

/** Firetracker-Design: warme Akzentfarbe, sonst zurückhaltend. */
export const theme = createTheme({
  primaryColor: 'orange',
  primaryShade: { light: 7, dark: 6 },
  defaultRadius: 'md',
  fontFamily:
    'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: { fontWeight: '600' },
  components: {
    // Kompaktes numerisches Datumsformat statt „Oktober 16, 2026“ (einzelne Felder überschreiben es mit den Präferenzen)
    DatePickerInput: DatePickerInput.extend({ defaultProps: { valueFormat: 'DD.MM.YYYY' } }),
    DateTimePicker: DateTimePicker.extend({ defaultProps: { valueFormat: 'DD.MM.YYYY HH:mm' } }),
  },
});
